/* eslint-disable no-restricted-imports */
import React, { useContext, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import cf from '../../services/codeformatter';
import { injectIntl, useIntl } from "react-intl";
import { FlitServiceContext } from "../../services/flitService";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useDropzone } from 'react-dropzone';
import { CircularProgress } from '@material-ui/core'
import { DOCUMENT_TYPE } from "../../services/flitEnum";

const DocumentUploadByType = (props) => {
    const intl = useIntl();
    const { docs, activityId, businessEntity, documentType, isRequired, refreshHandler, hideOptional, isOperatorOnly, isReadOnly, templateUrl } = props;
    const { flitSvc } = useContext(FlitServiceContext);
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (docs && docs.length > 0) {
            setFiles(docs.map(doc => ({ id: doc.id, name: doc.fileName })));
        } else {
            setFiles([]);
        }
    }, [docs]);

    function downloadFile(documentId, fileName) {
        setIsLoading(true);
        flitSvc.getDownloadLink(documentId).then(res => {
            setIsLoading(false);
            // on the fly download trick
            const link = document.createElement('a');
            link.href = res.data.url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }

    return (
        <div style={{ justifyContent: "space-between"}}>
            <Form.Group controlId="documentId" className="mb-2">
                <Form.Label>
                    <CheckCircleIcon color={files.length > 0 ? 'secondary' : 'disabled'} /> 
                    {cf.format('DocumentType', documentType, intl.locale)} 
                    {templateUrl && <a href={templateUrl}>({intl.formatMessage({ id: "TEMPLATE" })})</a>} 
                    {!hideOptional && (isRequired ? " *" : "(Optional)")} 
                    {isLoading && <CircularProgress size={"15px"}/>}
                </Form.Label>
                {files.length > 0 ? (
                    <ul className='ml-3' style={{ paddingLeft: '20px', marginBottom: '8px' }}>
                        {files.map((file, index) => (
                            <li key={file.id || index} style={{ marginBottom: '4px' }}>
                                {'File: ' + file.name}
                                <span style={{ cursor: "pointer" }} onClick={() => downloadFile(file.id, file.name)}>
                                    <AttachFileIcon color='secondary' style={{ float: 'right' }} />
                                </span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <li className='ml-3' style={{ marginBottom: '8px' }}>{intl.formatMessage({ id: "DOCUMENT_NOT_UPLOADED" })}</li>
                )}
                {!isReadOnly && <FlitDropZone flitSvc={flitSvc} setFiles={setFiles} files={files} activityId={activityId} businessEntity={businessEntity} documentType={documentType} refreshHandler={refreshHandler} setIsLoading={setIsLoading} isOperatorOnly={isOperatorOnly}/>}
            </Form.Group>
        </div>
    );
}

const FlitDropZone = (props) => {
    const intl = useIntl();
    const { flitSvc, setFiles, files, activityId, businessEntity, documentType, refreshHandler, setIsLoading, isOperatorOnly } = props;
    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        accept: {'image/*' : [] ,
            'text/*' : [],
            'application/msword' : [],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : [],
            'application/vnd.ms-excel' : [],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : [],
            'application/pdf' : [],
            'application/x-hwp' : ['.hwp']
        },
        maxSize : 10485760,
        multiple: false,
        onDropAccepted: acceptedFiles => {

            acceptedFiles.forEach(file => {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                
                reader.onload = () => {
                    setIsLoading(true);
                    if (activityId) {
                        flitSvc.uploadDocument(activityId, "", "", documentType, "", file.name, "", reader.result, isOperatorOnly).then((data) => {
                            const newFile = { id: data.data.id, name: file.name };
                            setFiles([...files, newFile]);
                            setIsLoading(false);
                            if (refreshHandler) refreshHandler();
                        })
                    } else if (businessEntity) {
                        flitSvc.uploadDocument(activityId, "", "", documentType, "", file.name, "", reader.result, isOperatorOnly).then((data) => {
                            const newFile = { id: data.data.id, name: file.name };
                            if(documentType == DOCUMENT_TYPE.POWER_OF_ATTORNEY) {
                                businessEntity.powerOfAttorneyDocumentId = newFile.id;
                            } else if (documentType == DOCUMENT_TYPE.CEO_PASSPORT) {
                                businessEntity.ceoPassportDocumentId = newFile.id;
                            } 
                            flitSvc.updateBusinessEntity(businessEntity).then((data) => {
                                setFiles([...files, newFile]);
                                setIsLoading(false);
                                if (refreshHandler) refreshHandler();
                            })
                        });
                    }
                };
                
            });
        }
    });

    // Dynamic styling based on number of files
    const getDropzoneStyle = () => {
        if (files.length > 1) {
            // Compact mode for 0-3 files to maintain grid layout
            return { padding: "0px 10px" };
        } else {
           return { padding: "15px 10px" };
        }
    };
    return (
        <>
            <div {...getRootProps({ className: 'dropzone dropzone-default m-3' })}>
                <input {...getInputProps()} />
                <div className="dropzone-msg-desc" style={getDropzoneStyle()}>
                    {intl.formatMessage({ id: "DROPZONE_DESC" }) }
                </div>
            </div>
            <div className="fv-plugins-message-container">
                <div className="fv-help-block">{fileRejections.length>0? intl.formatMessage({ id: "DOCUMENT_NOT_SUPPORTED" }) : ""}</div>
            </div>
        </>
    )
}

export default injectIntl(DocumentUploadByType);